/**
 * Podrazumevana polazna stanica — lokalno po uređaju (stranica Podešavanja).
 * Popunjava se SAMO u prazan formular pretrage. Fail-open: pokvaren zapis
 * znači „nije podešeno", nikad grešku.
 */

const KEY = "defaultDepartureStation";

export function getDefaultStation() {
    try {
        const raw = window.localStorage.getItem(KEY);
        const parsed = raw ? JSON.parse(raw) : null;
        if (parsed && typeof parsed.id === "number" && typeof parsed.name === "string") {
            return parsed;
        }
        return null;
    } catch {
        return null;
    }
}

export function setDefaultStation(station) {
    try {
        window.localStorage.setItem(KEY, JSON.stringify({ id: station.id, name: station.name }));
    } catch {
        // best-effort
    }
}

export function clearDefaultStation() {
    try {
        window.localStorage.removeItem(KEY);
    } catch {
        // best-effort
    }
}
